var n = /* @__PURE__ */ ((t) => (t.blue = "blue", t.red = "red", t.orange = "orange", t.green = "green", t.purple = "purple", t.gray = "gray", t))(n || {}), s = /* @__PURE__ */ ((t) => (t.light = "light", t.dark = "dark", t))(s || {}), g = /* @__PURE__ */ ((t) => (t.Base = "base", t.Border = "border", t.Button = "button", t))(g || {});
const d = (t) => `theme-gradient-${t}`, b = (t, r) => r ? `theme-${r}-${t}` : `theme-${t}`, $ = (t, r) => {
  const e = t, a = r ?? "dark";
  return {
    base: `theme-${a}-${e}`,
    border: `theme-border-${a}-${e}`,
    button: `theme-${e}`
  };
};
export {
  n as ThemeColor,
  g as ThemeColorClassTypes,
  s as ThemeShades,
  $ as getCustomThemeColorClass,
  d as getGradientClass,
  b as getThemeColorClass
};
//# sourceMappingURL=themeColor.js.map
